import React from 'react';
import { X } from 'lucide-react';
import { colors, shadows, radii } from '../../theme';

export default function Modal({ open, onClose, title, children, width = 520 }) {
  if (!open) return null;
  return (
    <div
      onClick={onClose}
      className="sf-fade-in"
      style={{
        position: 'fixed', inset: 0,
        background: 'rgba(15,23,42,0.45)',
        backdropFilter: 'blur(4px)',
        WebkitBackdropFilter: 'blur(4px)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        zIndex: 1000, padding: 16
      }}
    >
      <div
        onClick={e => e.stopPropagation()}
        className="sf-pop-in"
        style={{
          background: colors.surface, borderRadius: radii.xl, width: '100%', maxWidth: width,
          maxHeight: '90vh', display: 'flex', flexDirection: 'column',
          boxShadow: shadows.xl, border: `1px solid ${colors.border}`
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '18px 22px', borderBottom: `1px solid ${colors.border}` }}>
          <h2 style={{ margin: 0, fontSize: 17, fontWeight: 700, color: colors.text, letterSpacing: '-0.01em' }}>{title}</h2>
          <button onClick={onClose} style={{ background: colors.surfaceMuted, border: 'none', cursor: 'pointer', padding: 6, borderRadius: 8, color: colors.textMuted, display: 'flex' }}>
            <X size={18} />
          </button>
        </div>
        <div style={{ padding: 22, overflowY: 'auto' }}>
          {children}
        </div>
      </div>
    </div>
  );
}
